import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function Terms() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Terms of Service" subtitle={`These Terms govern your access to and use of ${COMPANY.brand} products and ${COMPANY.website}.`} />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing {COMPANY.website} or using {COMPANY.brand} (the “Service”), you agree to be bound by these Terms of Service and all applicable laws. If you do not agree, do not use the Service.</p>

        <h2>2. Eligibility</h2>
        <p>You must be at least 18 years old (or the age of majority in your jurisdiction) to purchase or subscribe to our Service.</p>

        <h2>3. Accounts and Subscriptions</h2>
        <ul>
          <li>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</li>
          <li>Subscription plans are billed in advance on a monthly or annual basis. Prices are shown at checkout, exclusive of applicable taxes.</li>
          <li>Auto-renewal continues until you cancel. You can cancel at any time from your account or by contacting support.</li>
        </ul>

        <h2>4. License to Use</h2>
        <p>Subject to these Terms, {COMPANY.legalName} grants you a limited, non-exclusive, non-transferable license to install and use {COMPANY.brand} on Android devices you own or control for personal, non-commercial purposes.</p>

        <h2>5. Prohibited Uses</h2>
        <ul>
          <li>Reverse engineering, decompiling, or attempting to derive the source code of the Service.</li>
          <li>Using the Service for any unlawful, harmful, or fraudulent activity.</li>
          <li>Circumventing licensing controls, quotas, or security features.</li>
        </ul>

        <h2>6. Third-Party Services</h2>
        <p>The Service may integrate with third-party products or services. We are not responsible for the availability or content of any third-party service.</p>

        <h2>7. Intellectual Property</h2>
        <p>All content, trademarks, and software associated with {COMPANY.brand} are the exclusive property of {COMPANY.legalName} and are protected by applicable intellectual property laws.</p>

        <h2>8. Disclaimer of Warranties</h2>
        <p>The Service is provided “as is” and “as available”, without warranties of any kind. We do not warrant that the Service will be uninterrupted, error-free, or that all threats will be detected.</p>

        <h2>9. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, {COMPANY.legalName} shall not be liable for any indirect, incidental, consequential, or punitive damages arising out of or related to your use of the Service. Our aggregate liability shall not exceed the amount paid by you in the twelve (12) months preceding the claim.</p>

        <h2>10. Termination</h2>
        <p>We may suspend or terminate your access to the Service at any time for breach of these Terms. Upon termination, your right to use the Service ceases immediately.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms are governed by the laws of India, without regard to conflict of law principles. Any disputes shall be subject to the exclusive jurisdiction of the courts located in Navi Mumbai, Maharashtra, India.</p>

        <h2>12. Contact</h2>
        <p>Questions about these Terms? Contact {COMPANY.legalName} at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>
      </LegalBody>
    </>
  );
}
